export const MAX_PARTICIPANTS_GROUP = 4;
export const DEFAULT_EVENT_OPEN_MINUTES = 30;
export const DEFAULT_EVENT_CLOSES_MINUTES = 60;
export const CURRENT_USERID = "LcManz3it4NWQLwut916puJpLL62";
export const DEFAULT_KEEP_ALIVE_INTERVAL = 200000; // after this amount of miliseconds, a new keep alive message is sent
export const DEFAULT_OFFLINE_INTERVAL = 420000; // after this amount of miliseconds of not being seen, the user is considered as offline
export const DEFAULT_KEEP_ALIVE_CHECK_INTERVAL = 60000; // interval when the calculation of the groups are done on the client side
